import { SplatTurretActor } from "./../SplatTurretActor";
import * as Anuto from "../../../../../engine/src";
import { GameVars } from "../../../../GameVars";
import { AudioManager } from "../../../../AudioManager";

export class GluePool extends Phaser.GameObjects.Container {

    public id: number;

    private splatTurretActor: SplatTurretActor;
    private anutoGlue: Anuto.Glue;

    constructor(scene: Phaser.Scene, splatTurretActor: SplatTurretActor, anutoGlue: Anuto.Glue) {

        super(scene);

        this.splatTurretActor = splatTurretActor;
        this.anutoGlue = anutoGlue;

        this.id = anutoGlue.id;

        this.x = this.splatTurretActor.x;
        this.y = this.splatTurretActor.y;

        let img = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "glue_pool");
        this.add(img);

        this.scene.tweens.add({
            targets: this,
            scaleX: 1,
            scaleY: 1,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: GameVars.timeStepFactor === 1 ? 600 : 200
        });

        this.setScale(0);
        this.alpha = 0;

        // AudioManager.playSound("t3_pegamento");
    }

    public destroy(): void {

        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: GameVars.timeStepFactor === 1 ? 1200 : 400,
            onComplete: () => {
                super.destroy();
            },
            onCompleteScope: this
        });
    }
}
